import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PublicHeader from '../../components/ui/PublicHeader';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const HomeLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash !== '#how-it-works') return;
    const t = window.setTimeout(() => {
      document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
    }, 150);
    return () => window.clearTimeout(t);
  }, [location.pathname, location.hash]);

  const handleJoinFree = () => {
    navigate('/registration-login', { state: { gender: 'female' } });
  };

  const handleStartJourney = () => {
    navigate('/registration-login', { state: { gender: 'male' } });
  };

  return (
    <>
      <Helmet>
        <title>Bamchik - Discreet Dating Platform for Anonymous Connections</title>
        <meta 
          name="description" 
          content="Join Bamchik, the most secure platform for discreet dating and anonymous connections. Free for women, premium features for men. 100% private and judgment-free." 
        />
        <meta name="keywords" content="discreet dating, anonymous dating, private connections, secure messaging, adult dating" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <PublicHeader />
        
        <HeroSection 
          onJoinFree={handleJoinFree}
          onStartJourney={handleStartJourney}
        />
        
        <BenefitsSection />
        
        <HowItWorksSection />
        
        <TestimonialsSection />
        
        <CTASection 
          onJoinFree={handleJoinFree}
          onStartJourney={handleStartJourney}
        />
        
        <Footer />
      </div>
    </>
  );
};

export default HomeLanding;